export const DEFAULT_ERROR_MESSAGE = 'Произошла непредвиденная ошибка';
